import React from 'react'
import { Box, Typography } from '@mui/material'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'

type CommentPreviewProps = {
	comment: string
	canEdit: boolean
	onClick: () => void
	maxHeight?: number
}

const DEFAULT_MAX_HEIGHT = 72

const CommentPreview = ({
	comment,
	canEdit,
	onClick,
	maxHeight = DEFAULT_MAX_HEIGHT,
}: CommentPreviewProps) => {
	const hasComment = Boolean(comment?.trim())
	const isInteractive = canEdit || hasComment

	return (
		<Box
			onClick={isInteractive ? onClick : undefined}
			sx={{
				display: 'flex',
				alignItems: 'flex-start',
				gap: 0.75,
				minHeight: 44,
				maxHeight,
				cursor: isInteractive ? 'pointer' : 'default',
				borderRadius: 1,
				px: 0.5,
				py: 0.25,
				'&:hover': isInteractive ? { backgroundColor: 'action.hover' } : undefined,
			}}
		>
			<Box
				sx={{
					flex: 1,
					minWidth: 0,
					maxHeight,
					overflowY: 'auto',
					whiteSpace: 'pre-wrap',
					wordBreak: 'break-word',
				}}
			>
				{hasComment ? (
					<Typography variant='body2' component='span'>
						{comment}
					</Typography>
				) : canEdit ? (
					<Typography variant='body2' color='text.secondary' sx={{ fontStyle: 'italic' }}>
						Add comment
					</Typography>
				) : (
					<Typography variant='body2' color='text.disabled'>
						—
					</Typography>
				)}
			</Box>
			{canEdit && (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						color: 'action.active',
						pt: 0.25,
						flexShrink: 0,
					}}
				>
					{hasComment ? (
						<EditOutlinedIcon sx={{ fontSize: 18 }} />
					) : (
						<ChatBubbleOutlineIcon sx={{ fontSize: 18 }} />
					)}
				</Box>
			)}
		</Box>
	)
}

export default CommentPreview
